import { renderEUDate } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const doctorColumn = {
  size: 100,
  muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  filterVariant: "select",
  accessorFn: (row) =>
    row.doctor_id === null
      ? ""
      : `${row.doctor.first_name} ${row.doctor.last_name}`,
  muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  id: "professionista_sanitario",
  header: "Prof. Sanitario",
};

const orgColumn = {
  size: 25,
  muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  accessorKey: "org_name",
  filterVariant: "select",
  muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  header: "Org",
};

export const getPatientsColumns = ({ showDoctor = true, showOrg = true } = {}) => {
  const columns = [
    {
      size: 100,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      filterFn: "contains",
      accessorFn: (row) => `${row.first_name} ${row.last_name}`,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Paziente",
    },
    {
      size: 100,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      filterFn: "contains",
      accessorFn: (row) => renderEUDate(row.date_of_birth),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Data di nascita",
    },
    {
      size: 75,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      filterFn: "contains",
      accessorKey: "city",
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Citt�",
    },
    {
      size: 75,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      filterFn: "contains",
      accessorFn: (row) => row.phone || row.mobile || "",
      id: "phone",
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Telefono",
    },
    {
      size: 75,
      accessorKey: "status",
      id: "is_active",
      enableColumnFilter: true,
      accessorFn: (row) => (row.is_active ? "true" : "false"),
      filterVariant: "select",
      Cell: ({ cell }) =>
        cell.getValue() === "true" ? (
          <DoneIcon color="success" />
        ) : (
          <CloseIcon color="error" />
        ),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Filtra" },
      filterSelectOptions: [
        { text: <DoneIcon color="success" />, value: "true" },
        { text: <CloseIcon color="error" />, value: "false" },
      ],
      header: "Attivo",
    },
  ];

  if (showDoctor) {
    columns.splice(1, 0, doctorColumn);
  }

  if (showOrg) {
    columns.push(orgColumn);
  }

  return columns;
};
